var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-block" },
    [
      _c("block-edit", {
        staticClass: "intro",
        attrs: {
          placeholder: "Insert intro text here",
          isNew: false,
          value: _vm.value
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          },
          "new-block": function($event) {
            return _vm.$emit("new-block", $event)
          },
          "new-init-done": function($event) {
            _vm.block.new = false
          }
        }
      }),
      _vm._v(" "),
      _c("a", { staticClass: "drag" }),
      _vm._v(" "),
      _c("a", {
        staticClass: "remove",
        on: {
          click: function($event) {
            return _vm.$emit("remove")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }